import { createRouter, createWebHistory } from 'vue-router'
// import Home from '../views/Home.vue'
import Landing from '../views/Landing.vue'


const routes = [
  {
    path: '/',
    name: 'Landing',
    component: Landing
  },
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

export default router
